<template>
  <div class="body">
  <div class="cus-container">
    <div class="cus-row">
      <div class="cus-col cus-col-8p">
        <h5 class="cus-h5 cus-center-tx">VERITAS MARITIME CORPORATION</h5>
        <h6 class="cus-h6 cus-center-tx">Date: 08 August 2020</h6>
        <div class="cus-row cus-bold cus-p1-top">
          <div class="cus-col cus-col-6p cus-p1-right">
            <table width="100%" class="single-table">
              <tr>
                <td>Name of Seaman</td>
                <td>:</td>
                <td>ABAD, SIR JAMES JUAYAN</td>
              </tr>
              <tr>
                <td>Higher License</td>
                <td>:</td>
                <td> </td>
              </tr>
              <tr>
                <td>Current Activity</td>
                <td>:</td>
                <td>STAND BY</td>
              </tr>
              <tr>
                <td>Vessel</td>
                <td>:</td>
                <td> BALTIC HIGHWAY </td>
              </tr>
              <tr>
                <td>Start/Embarkation</td>
                <td>:</td>
                <td>07 Sep 2020</td>
              </tr>
            </table>
          </div>
          <div class="cus-col cus-col-4p cus-p1-x">
            <table class="single-table small-table" width="100%">
              <tr>
                <td>Crew IPN</td>
                <td>:</td>
                <td>2016E288</td>
              </tr>
              <tr>
                <td>Rank</td>
                <td>:</td>
                <td>OILER</td>
              </tr>
              <tr>
                <td>Flag</td>
                <td>:</td>
                <td>PANAMA</td>
              </tr>
              <tr>
                <td>Type</td>
                <td>:</td>
                <td>PCC</td>
              </tr>
              <tr>
                <td>Status</td>
                <td>:</td>
                <td>PLAN</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="cus-col cus-col-2p cus-p1-top">
        <img src="../../../../../../assets/crew.png"
             alt="Abad, Sir James Juayan"
             class="cus-border" style="width: 100%">
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">PERSONAL INFORMATION</h6>
        <div class="cus-row cus-bold cus-p1-top">
          <div class="cus-col cus-col-6p cus-p1-right">
            <table class="single-table" width="100%">
              <tr>
                <td>Place of Birth</td>
                <td>:</td>
                <td>BACOLOD CITY</td>
              </tr>
              <tr>
                <td>Religion</td>
                <td>:</td>
                <td>ROMAN CATHOLIC</td>
              </tr>
              <tr>
                <td>Next of Kin</td>
                <td>:</td>
                <td>ABAD, JAHZEEL (MOTHER)</td>
              </tr>
              <tr>
                <td>Address</td>
                <td>:</td>
                <td> </td>
              </tr>
              <tr>
                <td>Telephone No.</td>
                <td>:</td>
                <td> 0919-4537434 </td>
              </tr>
              <tr>
                <td>Address</td>
                <td>:</td>
                <td>#9 MAGSAYSAY AVE. SINGCANG, BACOLOD CITY, NEGROS OCCIDENTAL</td>
              </tr>
              <tr>
                <td>Telephone No.</td>
                <td>:</td>
                <td> </td>
              </tr>
            </table>
          </div>
          <div class="cus-col cus-col-4p cus-p1-left">
            <table class="single-table" width="100%">
              <tr>
                <td>Date of Birth</td>
                <td>:</td>
                <td>23 Jul  1983</td>
              </tr>
              <tr>
                <td>Age</td>
                <td>:</td>
                <td>27</td>
              </tr>
              <tr>
                <td>Height (cm)</td>
                <td>:</td>
                <td>98</td>
              </tr>
              <tr>
                <td>Disembark Weight (kg)</td>
                <td>:</td>
                <td>59 - Normal (20)</td>
              </tr>
              <tr>
                <td>Civil Status</td>
                <td>:</td>
                <td>Single</td>
              </tr>
              <tr>
                <td>Driver Licence</td>
                <td>:</td>
                <td> </td>
              </tr>
              <tr>
                <td>Blood Type</td>
                <td>:</td>
                <td>O</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">MEDICAL</h6>
        <div class="cus-row cus-bold cus-p1-top">
          <div class="cus-col cus-col-5p cus-p1-right">
            <table class="single-table" width="100%">
              <tr>
                <td>PEME Date</td>
                <td>:</td>
                <td> 05 Aug 2019</td>
              </tr>
              <tr>
                <td>Conducted By</td>
                <td>:</td>
                <td>K LINE CLINIC</td>
              </tr>
            </table>
          </div>
          <div class="cus-col cus-col-5p cus-p1-left">
            <table class="single-table" width="100%">
              <tr>
                <td>Result</td>
                <td>:</td>
                <td>FIT TO WORK</td>
              </tr>
              <tr>
                <td>POST MEDICAL Date</td>
                <td>:</td>
                <td>28 Mar 2019</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">EDUCATIONAL ATTAINMENT</h6>
        <div class="cus-row cus-bold cus-p1-top">
          <div class="cus-col cus-col-10 cus-p1-right">
            <table class="default" width="100%">
              <tr>
                <td>School :</td>
                <td>VMC GLOBAL COLLEGE</td>
                <td>Course :</td>
                <td>B.S. MARINE ENGINEERING</td>
                <td>Year :</td>
                <td>2017</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">DOCUMENTS AND LICENSES</h6>
        <table class="cus-p1-top document-table" width="100%">
          <tr class="cus-bold">
            <td>Document</td>
            <td>Rank</td>
            <td>Doc No.</td>
            <td>Issued</td>
            <td>Expiry</td>
          </tr>
          <tr>
            <td>PHILIPPINE SEAMANS BOOK</td>
            <td>N/A</td>
            <td>C0800820</td>
            <td>20 May 2016</td>
            <td>19 May 2021</td>
          </tr>
          <tr>
            <td>ENDORSEMENT OF CERTIFICATE</td>
            <td>N/A</td>
            <td>EOICEW200000217919</td>
            <td>12 Jul 2019</td>
            <td>12 Jul 2024</td>
          </tr>
          <tr>
            <td>CERTIFICATE OF COMPETENCY for OFFICERS </td>
            <td>N/A</td>
            <td>COICEW200000216519</td>
            <td>12 Jul 2019</td>
            <td>12 Jul 2024</td>
          </tr>
          <tr>
            <td>PHILIPPINE GOC</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PANAMA SEAMAN BOOK</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PANAMA LICENSE</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PAN-GMDSS SEAMANS BOOK </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PANAMA GMDSS LICENSE </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PANAMA ENDORSEMENT SDSD </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PHILIPPINE PASSPORT </td>
            <td>N/A</td>
            <td>EC8039899</td>
            <td>15 Jun 2016</td>
            <td>14 Jun 2021</td>
          </tr>
          <tr>
            <td>US VISA </td>
            <td>N/A</td>
            <td>RC1/D20192545270001</td>
            <td>16 Sep 2019</td>
            <td>10 Sep 2024 </td>
          </tr>
          <tr>
            <td>AUSTRALIAN MCV </td>
            <td>N/A</td>
            <td>2009589393731</td>
            <td>08 Aug 2019</td>
            <td>08 Aug 2022</td>
          </tr>
          <tr>
            <td>POST MED </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>05 Aug 2019</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PEME </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>28 Mar 2019</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>YELLOW FEVER </td>
            <td>N/A</td>
            <td>QJ 060808 </td>
            <td>20 Sep 2016 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>VACCINE CERTIFICATE </td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">TRAININGS</h6>
        <table class="cus-p1-top document-table" width="100%">
          <tr class="cus-bold">
            <td>Document</td>
            <td>Issued</td>
            <td>Grade/Expiry</td>
          </tr>
          <tr>
            <td>SSBT W/ BRM </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>SHIP SECURITY OFFICER </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ELECTRONIC CHART DISPLAY AND INFORMATION SYSTEM </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ECDIS-FURUNO </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ECDIS FURUNO FEA-2107/FEA-2807 </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ECDIS JRC 7201/9201 </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ECDIS JRC 701/901/901M </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>SECDIS-TOKYO KEIKI </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>AUTOMATIC IDENTIFICATION SYSTEM (AIS) </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>STCW 95 - BASIC SAFETY COURSE </td>
            <td>09 Feb 2016</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>ADVANCED TRAINING IN FIREFIGHTING </td>
            <td>27 Jul 2016 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>MEDICAL EMERGENCY - FIRST AID </td>
            <td>30 Jul 2016 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>PROF. IN SURVIVAL CRAFT & RESCUE BOAT </td>
            <td>21 Jul 2016</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>FREE FALL LIFE BOAT LAUNCHING </td>
            <td>28 Sep 2016</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>SAFE PRACITES & HANDLING OF FUMIGATED CARGO </td>
            <td>30 Jul 2019 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>REAL DANGER SENSING COURSE</td>
            <td>10 Jul 2019 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>KRBS SMS 3.0 </td>
            <td>13 Apr 2018</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>KRBS SMS REFRESHER </td>
            <td>14 Jun 2019 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>KRBS ISM/SMS </td>
            <td>15 Jun 2019</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS FOR PCC </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>K-LINE ENVIRONMENTAL MANAGEMENT SYSTEM(EMS) </td>
            <td>14 Jun 2019</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS-GAS DETECTOR CALIBRATION (MODEL GX-8000) </td>
            <td>10 Jun 2019 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>MARITIME LABOUR CONVENTION (MLC) 2006 FAMILIARIZATION COURSE </td>
            <td>18 Oct 2019 </td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS BASIC NAVIGATION </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>KRBS BASSNET </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TOS SPAS/DIGITRACE </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS-ADMIRALTY E-NAVIGATOR PLANNING STATION WORKSHOP </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS NICKEL ORE CARGO FAMILIARIZATION </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>TTOS NISHI-F LRRS </td>
            <td>15 Nov 2016</td>
            <td>N/A</td>
          </tr>
          <tr>
            <td>CRANE OPERATOR </td>
            <td>N/A</td>
            <td>N/A</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10">
        <h6 class="cus-h6 cus-bg-gray-5p cus-p1-x">EXPERIENCE SEABASED</h6>
        <table class="cus-p1-top document-table" width="100%" id="experience-table">
          <tr class="cus-bold">
            <td>Company</td>
            <td>Vessel</td>
            <td>Rank</td>
            <td>GRT</td>
            <td>Engine/KW</td>
            <td>Type</td>
            <td>Trade Route</td>
            <td>Embkd</td>
            <td>Disembkd</td>
            <td>Mo</td>
            <td>Reason</td>
            <td>Grd</td>
          </tr>
          <tr>
            <td>Veritas</td>
            <td>CAPE CANARY</td>
            <td>OLR</td>
            <td>93235.00</td>
            <td>/</td>
            <td>BULK</td>
            <td>WW</td>
            <td>20 Oct 2019</td>
            <td>Present</td>
            <td>9</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr>
            <td>Veritas</td>
            <td>CAPE CANARY</td>
            <td>OLR</td>
            <td>93235.00</td>
            <td>/</td>
            <td>BULK</td>
            <td>WW</td>
            <td>29Sept2019</td>
            <td>Present</td>
            <td>9</td>
            <td>--</td>
            <td>--</td>
          </tr>
          <tr>
            <td>Veritas</td>
            <td>CAPE VANGUARD</td>
            <td>WPR</td>
            <td>104732.00</td>
            <td>KAWASAKI B&W/0</td>
            <td>BULK</td>
            <td>WW</td>
            <td>06Jul2018</td>
            <td>26Mar2019</td>
            <td>9</td>
            <td>FC</td>
            <td>95.0</td>
          </tr>
          <tr>
            <td>Veritas</td>
            <td>CAPE VANGUARD</td>
            <td>E/C-ME+</td>
            <td>104732.00</td>
            <td>KAWASAKI B&W/0</td>
            <td>BULK</td>
            <td>WW</td>
            <td>24Nov2016</td>
            <td>24Dec2017</td>
            <td>13</td>
            <td>FC</td>
            <td>90.0</td>
          </tr>
        </table>
      </div>
    </div>
    <div class="cus-row cus-p1-top">
      <div class="cus-col cus-col-10 cus-p1-top">
        <p class="cus-p1-top font-ten">
          <b>Legend:</b> <br />
          <b>CF -</b> CHANGE FLAG <b>CG -</b> Compassionate Grounds <b>CM -</b> Change Management <b>CR -</b> Company Request <b>CV -</b> Chang Vessel Name <b>DC -</b>
          Deceased <b>DM -</b> Dismissed <b>FC -</b> Finished Contract <b>FP -</b> Finish Contract/PNI <b>IA -</b> ITF Avoid <b>IF -</b> ITF Trouble <b>MS -</b> Missing Onboard <b>OR -</b> Own
          Request <b>PI -</b> P&I Case (Injury) <b>PO -</b> PRINCIPALS REQUEST <b>PR -</b> Promotion Onboard <b>PS -</b> P&I Case (Illness) <b>RL -</b> Reliever <b>TA -</b> Transfer
          Rank <b>TV -</b> Transfer Vessel <b>VL -</b> Vessel Sold <b>VS -</b> Vessel Scrapped <b>VU -</b> Vessel Lay Up <b>VW -</b> Vessel Wreck
        </p>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
name: "CrewBiodata",
  methods: {
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap');
* {
  margin: 0;
  padding: 0;
  font-family: 'Noto Sans JP', sans-serif;
  font-size: 12px;
}
.body {
  padding: 50px 0;
  background: #999999;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cus-container {
  /*width: 700px;*/
  text-align: left;
  width: 796px;
  background: #ffffff;
  box-sizing: border-box;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  padding: 48px;
}
.single-table tr td:nth-child(3n) {
  border-bottom: 1px solid #999999;
  font-weight: normal;
  padding: 0 5px;
}
.single-table tr td:nth-child(2n) {
  padding: 0 5px;
  width: 10px;
}
.single-table tr td:first-child {
  width: 120px;
}
.small-table tr td:first-child {
  width: 60px;
}
.default tr td {
  width: auto;
  padding: 0;
  margin: 0;
  border-bottom: none;
  font-weight: bold;
}
.default tr td:nth-child(2n) {
  border-bottom: 1px solid #999999;
  font-weight: normal;
  padding: 0 5px;
}
.default tr td:nth-child(2n -1) {
  width: 50px;
}
.default tr td:nth-child(3), .default tr td:nth-child(5) {
  padding-left: 20px;
}
.document-table {
  margin-top: 10px;
  border-collapse: collapse;
}
.document-table tr td {
  border: 1px solid #999999;
  text-align: center;
  font-size: 10px;
}
.document-table tr:nth-child(n + 2) td:first-child {
  text-align: left;
  padding: 0 5px;
}
#experience-table tr:nth-child(n + 2) td:first-child  {
  text-align: center;
}
#experience-table tr td:nth-child(7) {
  width: 38px;
}
.font-ten, .font-ten * {
  font-size: 9px;
}
.cus-h5 {
  font-family: inherit;
  font-size: 20px;
  font-weight: bold;
}
.cus-h6 {
  font-family: inherit;
  font-size: 16px;
  font-weight: bold;
}
.cus-p1-x {
  padding: 0 10px;
}
.cus-p1-top {
  padding-top: 10px;
}
.cus-p1-right {
  padding-right: 10px;
}
.cus-p1-left {
  padding-left: 10px;
}
</style>